export function getAlarmClass(value?: number): string {
    let result = '';
    switch (value) {
        case 1:
            result = 'alert-info';
            break;
        case 2:
            result = 'alert-warning';
            break;
        case 3:
            result = 'alert-danger';
            break;
    }
    return result;
}